<template>
  <!-- 新增分区编辑页面 -->
  <div class="page">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      :rules="rules"
    >
      <el-form-item label="分区类别" prop="typeName">
        <el-input v-model="ruleForm.typeName" size=""></el-input>
      </el-form-item>
      <el-form-item label="排序字段" prop="sort">
        <el-input
          v-model.number="ruleForm.sort"
          onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
          size=""
        ></el-input>
      </el-form-item>
      <!-- 按钮 -->
      <el-form-item label="">
        <el-button type="info" @click="getBack">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >修改</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        typeName: "", // 分区类别
        sort: "", // 排序字段
        id: "",
      },
      // 验证规则
      rules: {
        typeName: [
          { required: true, message: "请输入分区类别", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序字段", trigger: "blur" }],
      },
    };
  },
  created() {
    this.ruleForm = this.$route.query.data;
  },
  methods: {
    // 点击新增
    submitForm(formName) {
      console.log(this.form);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios
            .put("/admin/certificateType/updateFirmType", this.ruleForm)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功!",
                });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.typeName = "";
      this.ruleForm.sort = "";
    },

    // 返回
    getBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 30px;
  width: 400px;
}
</style>
